import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { UploadCloud } from "lucide-react";
import { Link } from "react-router-dom";
import { Demos } from "@/api/demos";
import DemoGrid from "./DemoGrid";
import { UploadDialog } from "./DemoDialogs";

/** The demos linked to one account, with an upload that links automatically. */
export default function AccountDemos({ accountId }: { accountId: string }) {
  const [uploading, setUploading] = useState(false);
  const demosQuery = useQuery({
    queryKey: ["demos", { accountId }],
    queryFn: () => Demos.list({ account_id: accountId }),
  });
  const demos = demosQuery.data ?? [];
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm text-mut-500">
          Demos linked to this account. Link existing ones from the{" "}
          <Link to="/demos" className="text-accent-azure hover:underline">
            Demos
          </Link>{" "}
          page.
        </p>
        <button className="btn" onClick={() => setUploading(true)}>
          <UploadCloud className="h-3.5 w-3.5" /> Upload for this account
        </button>
      </div>
      {demosQuery.isLoading ? (
        <p className="text-md text-mut-500">Loading…</p>
      ) : demos.length === 0 ? (
        <div className="panel px-6 py-10 text-center text-sm text-mut-500">
          No demos linked yet.
        </div>
      ) : (
        <DemoGrid demos={demos} />
      )}
      {uploading && (
        <UploadDialog onClose={() => setUploading(false)} defaultAccountIds={[accountId]} />
      )}
    </div>
  );
}
